export default __webpack_public_path__ + "static/comercial-trash-service-56e40488f71e907a0c8554397bd86300.jpg";